module.exports = __webpack_public_path__ + "img/services-details-1.80f76c01.jpg";